export async function saveSupplier(URL, token, data, file) {
    return data.id
        ? updateSupplier(URL, token, data, file)
        : createSupplier(URL, token, data, file);
}

export async function createSupplier(URL, token, data, file) {
    try {
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
            type: "application/json",
        });
        const formData = new FormData();
        formData.append("data", blob);
        formData.append("image", file);
        const response = await fetch(URL, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });
        if (response.ok) {
            return {
                success: true,
                status: response.status,
                data: await response.json(),
            };
        } else {
            return {
                success: false,
                status: response.status,
                message: `The error status code is ${response.status}`,
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}

async function updateSupplier(URL, token, data, file) {
    try {
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
            type: "application/json",
        });
        const formData = new FormData();
        formData.append("data", blob);
        formData.append("image", file);
        const response = await fetch(URL, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });
        if (response.ok) {
            return {
                success: true,
                status: response.status,
                data: await response.json(),
            };
        } else {
            return {
                success: false,
                status: response.status,
                message: `The error status code is ${response.status}`,
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}

export async function deleteSupplierById(URL, token) {
    try {
        const response = await fetch(URL, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.ok) {
            return {
                success: true,
                message: "DELETED",
            };
        } else {
            return {
                success: false,
                status: response.status,
                body: await response.json()
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}

export async function fetchDataSupplier(URL, token, data) {
    try {
        const response = await fetch(URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        if (response.ok) {
            return {
                success: true,
                data: await response.json(),
            };
        } else {
            return {
                success: false,
                status: response.status,
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}

export async function getFetchData(URL, token) {
    try {
        const response = await fetch(URL, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.ok) {
            return {
                success: true,
                data: await response.json(),
            };
        } else {
            return {
                success: false,
                status: response.status,
            };
        }
    } catch (err) {
        return {
            success: false,
            message: err.message,
        };
    }
}
